export const apiRoot = 'http://www.mocky.io/v2'
//http://www.mocky.io/v2/ 'https://vision-api.meetglimpse.com'
